import { useState } from 'react';

import { DealsItem } from '../DealsItem';
import { ListingsItem } from '../ListingsItem';
import { LoaderProgress } from '../../LoaderProgress';

import { tabs } from '../../../../data/constants';

export const RemindersList = ({ groups = [], type = '0' }) => {
  const [isLoading, setIsLoading] = useState(false);

  const isListings = [Number(tabs[1].value), Number(tabs[2].value)].includes(
    Number(type)
  );
  const Item = isListings ? ListingsItem : DealsItem;

  return (
    <>
      {isLoading && <LoaderProgress />}

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 w-full">
        {groups.map(group => (
          <Item
            key={group.key}
            reminder={group.head}
            group={group.reminders}
            setIsLoading={setIsLoading}
          />
        ))}
      </div>
    </>
  );
};
